import { memo, useCallback, useMemo, useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { COLOR, FONT, THEME, __WEB__ } from '../../constants/styles';
import { getAvailableFeaturesForStaff } from '../../selectors/employers';

import { I18n } from '../components';

const SCHEDULING_ICON = require('../../../resources/nav/icon-scheduling.png');
const PATIENTS_ICON = require('../../../resources/nav/icon-patients.png');
const STAFF_ICON = require('../../../resources/nav/icon-staff.png');
const BASE_SETUP_ICON = require('../../../resources/nav/icon-platform-setup.png');

import { HOME_TAB, SETUP_TAB } from '../../constants/tabs';

import { MainNavItem } from './sidebar_nav_item';

export default memo(function SideNav(props) {
  const dispatch = useDispatch();
  const availableFeatures = useSelector(getAvailableFeaturesForStaff);

  const openScreen = useCallback(
    (screenConfig) => {
      props.openScreen?.(screenConfig);
    },
    [props.openScreen]
  );

  const navItems = useMemo(() => {
    const items = [];
    if (!!__WEB__ && availableFeatures.staffScheduling) {
      items.push({
        label: 'Staff Scheduling',
        icon: SCHEDULING_ICON,
        screenConfig: { screen: 'Scheduling', nativeTab: HOME_TAB },
        selected: props.currentTab === 'Scheduling',
      });
    }
    if (availableFeatures.patients) {
      items.push({
        label: I18n.c1_aec('employer.residents'),
        icon: PATIENTS_ICON,
        screenConfig: { screen: 'Patients', nativeTab: HOME_TAB },
        selected: props.currentTab === 'Patients',
      });
    }
    if (availableFeatures.staff) {
      items.push({
        label: 'Staff',
        icon: STAFF_ICON,
        screenConfig: { screen: 'Staff', nativeTab: HOME_TAB },
        selected: props.currentTab === 'Staff',
      });
    }
    items.push({
      label: 'Base Setup',
      icon: BASE_SETUP_ICON,
      screenConfig: { screen: 'Setup', nativeTab: SETUP_TAB },
      selected: props.currentTab === 'Setup',
    });
    return items;
  }, [props.currentTab, availableFeatures]);

  const firstAvailableScreen = navItems?.[0]?.screenConfig;

  useEffect(() => {
    if (firstAvailableScreen) {
      openScreen(firstAvailableScreen);
    }
  }, [firstAvailableScreen?.screen, openScreen]);

  return (
    <>
      <View style={styles.mainNav}>
        {navItems.map((item) => (
          <MainNavItem key={item.label} {...item} onPress={openScreen} />
        ))}
      </View>
    </>
  );
});

const styles = StyleSheet.create({
  mainNav: {
    // backgroundColor: COLOR.labelText,
  },
});
